import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)



// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'home',
    component: resolve => require(['../views/pages/Home.vue'], resolve)
  },
  {
    path: '/myScripts',
    name: 'user-space',
    component: resolve => require(['../views/pages/UserSpace.vue'], resolve)
  },
  {
    path: '/myMaterials',
    name: 'user-material',
    component: resolve => require(['../views/pages/UserMaterial.vue'], resolve)
  },
  {
    path: '/pricing',
    name: 'pricing',
    component: resolve => require(['../views/pages/Pricing.vue'], resolve)
  },
  {
    path: '/account-settings',
    name: 'account-settings',
    component: resolve => require(['../views/pages/AccountSettings.vue'], resolve)
  },
  {
    path: '/accountRJF',
    name: 'account-manager',
    component: resolve => require(['../views/pages/AccountManager.vue'], resolve)
  },
  {
    path: '/accountVipRJF',
    name: 'account-vip-manager',
    component: resolve => require(['../views/pages/AccountVipManager.vue'], resolve)
  },
  {
    path: '/editor/:id',
    name: 'Editor',
    component: resolve => require(['../views/manager/Editor.vue'], resolve)
  },
  {
    path: '/editor-me/:id',
    name: 'EditorMe',
    component: resolve => require(['../views/manager/Editor.vue'], resolve),
    props: { mode: 'meme' }
  },
  {
    path: '/ai-preview/:previewId',
    name: 'AiPreview',
    component: resolve => require(['../views/manager/preview/FullPreview.vue'], resolve)
  },
  {
    path: '/autonomous-avatar',
    name: 'AutonomousAvatar',
    component: resolve => require(['../views/autonomousAvatar/AutonomousAvatar.vue'], resolve)
  },
  {
    path: '/autonomous-avatar/:id',
    name: 'AutonomousAvatarProject',
    component: resolve => require(['../views/autonomousAvatar/AutonomousAvatar.vue'], resolve)
  },
  {
    path: '/recharge',
    name: 'Recharge',
    component: resolve => require(['../views/manager/recharge/Recharge.vue'], resolve)
  },
  {
    path: '/imageSplitter',
    name: 'ImageSplitter',
    component: resolve => require(['../views/pages/ImageSplitter.vue'], resolve)
  },
  { path: '/login', name: 'Login', meta: { name: '登录' }, component: () => import('../views/Login.vue') },
  { path: '/register', name: 'Register', meta: { name: '注册' }, component: () => import('../views/Register.vue') },
  { path: '*', name: 'NotFound', meta: { name: '无法访问' }, component: () => import('../views/error/404.vue') },
  // {
  //   path: '/test',
  //   name: 'Manager',
  //   component: () => import('../views/Manager.vue'),
  //   redirect: '/myScripts',  // 重定向到主页
  //   children: [
  //     { path: '403', name: 'NoAuth', meta: { name: '无权限' }, component: () => import('../views/error/403.vue') },
  //     // { path: '/editor/:id', name: 'Editor', meta: { name: '系统首页' }, component: () => import('../views/manager/Editor.vue') },
  //     { path: 'draw', name: 'draw', meta: { name: '系统' }, component: () => import('../views/manager/Draw.vue') },
  //     { path: 'adminPerson', name: 'AdminPerson', meta: { name: '个人信息' }, component: () => import('../views/manager/AdminPerson') },
  //     { path: 'password', name: 'Password', meta: { name: '修改密码' }, component: () => import('../views/manager/Password') },
  //     { path: 'myScripts', name: 'MyScripts', meta: { name: '我的作品' }, component: () => import('../views/manager/MyScripts.vue') },
  //     { path: 'myPerson', name: 'MyPerson', meta: { name: '我的背景' }, component: () => import('../views/manager/MyPerson.vue') },
  //     { path: 'myBack', name: 'MyBack', meta: { name: '我的背景' }, component: () => import('../views/manager/MyBack.vue') },
  //     { path: 'myProp', name: 'MyProp', meta: { name: '我的道具' }, component: () => import('../views/manager/MyProp.vue') },
  //     { path: 'myFace', name: 'MyFace', meta: { name: '我的表情' }, component: () => import('../views/manager/MyFace.vue') },
  //     { path: 'myEffect', name: 'MyEffect', meta: { name: '我的特效' }, component: () => import('../views/manager/MyEffect.vue') },
  //     // { path: 'recharge', name: 'Recharge', meta: { name: '充值' }, component: () => import('../views/manager/recharge/Recharge.vue') },
  //     {
  //       path: '/a',
  //       name: 'home',
  //       component: resolve => require(['../views/pages/Home.vue'], resolve)
  //     },
  //   ]
  // },
  {
    path: '/front',
    name: 'Front',
    component: () => import('../views/Front.vue'),
    children: [
      { path: 'home', name: 'Home', meta: { name: '系统首页' }, component: () => import('../views/front/Home') },
      { path: 'person', name: 'Person', meta: { name: '个人信息' }, component: () => import('../views/front/Person') },
    ]
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 注：不需要前台的项目，可以注释掉该路由守卫
// 路由守卫
// router.beforeEach((to ,from, next) => {
//   let user = JSON.parse(localStorage.getItem("xm-user") || '{}');
//   if (to.path === '/') {
//     if (user.role) {
//       if (user.role === 'USER') {
//         next('/front/home')
//       } else {
//         next('/home')
//       }
//     } else {
//       next('/login')
//     }
//   } else {
//     next()
//   }
// })

export default router
